import { useQueryExec } from "../hooks/useQueryExec";
import { IonItem, IonLabel } from "@ionic/react";
import DefaultQueries from "./DefaultQueries";
import { useContext } from "react";
import { TranslationsContext } from "../util/Translations";

const DefaultCycleCountQuery: React.FC = () => {
  const { getQueryList, queryList } = useQueryExec(
    "Cycle Count",
    "Cycle Count",
    "cycle count"
  );
  const querySection = "QW--Cycle Count";
  const { translations } = useContext(TranslationsContext);

  return (
    <>
      <IonItem>
        <IonLabel position="stacked">
          {translations["lbl_mob_cyclecountquery"] ||
            "Default Cycle Count Query"}
        </IonLabel>
        <DefaultQueries
          getQueryList={getQueryList}
          queryList={queryList}
          querySection={querySection}
        />
      </IonItem>
    </>
  );
};
export default DefaultCycleCountQuery;
